import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class EventTypeToggle extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick(value) {
        const { handleUpdate } = this.props;

        handleUpdate({ "eventType": value, "page": 1});
    }

    renderEventTypeLinks = (eventTypeLink, key) => {
        const { eventType, eventTypeLinks, eventLinksDivider} = this.props;

        const buttonClass = classNames("btn btn--link", {
            "is-active": eventType === eventTypeLink.value || eventTypeLink.isActive && !eventType,
            "is-first": key === 0,
            "is-last": (key + 1) >= eventTypeLinks.length
        });

        const divider = key + 1 < eventTypeLinks.length ? eventLinksDivider : "";
        const linkValue = eventType === eventTypeLink.value ? [] : eventTypeLink.value;
        return ( <span key={key}><button onClick={() => this.handleClick(linkValue)} className={ buttonClass }>{ eventTypeLink.label }</button>{ divider }</span>);
    }

    render() {
        const { eventTypeLinks} = this.props;

        return (
            <div className="search__info-sort">
                { eventTypeLinks.length > 0 && eventTypeLinks.map((eventTypeLink, i) => {
                    return this.renderEventTypeLinks(eventTypeLink, i);
                }) }
            </div>
        );
    }
}

EventTypeToggle.defaultProps = {
  eventLinksDivider: ' | '
}

const { string, func, array } = PropTypes;

EventTypeToggle.propTypes = {
    handleUpdate: func,
    eventType: string,
    eventTypeLinks: array.isRequired
};
